// extracted by mini-css-extract-plugin
module.exports = {"pagination":"e_wbb"};